export default "__VITE_ASSET__CuHcaK7x__"